import { gql } from '@apollo/client';

export const GET_APPS_ROL = gql`
    query GetPantallaRol($idRol: Int!) {
        pantallaRol(idRol: $idRol) {
            success
            error
            valorEsperado {
                idApp
                escritura
                dataPrivacy
            }
        }
    }
`;